import ContentLayout from '@/layouts/content-layout'
import SettingsView from '@/sections/settings/view/settings-view'

export default function SettingsPage() {
  return (
    <ContentLayout title="ตั้งค่า">
      <SettingsView />
    </ContentLayout>
  )
}
